import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Contact</h1>
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-700">
            Back to Home
          </Link>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">
          Need help? Reach us at <span className="font-semibold">support@songzug.com</span>
          or use the help center for common questions.
        </p>
        <div className="mt-4 space-y-3 text-sm text-gray-600">
          <p><strong>Email:</strong> support@songzug.com</p>
          <p><strong>Phone:</strong> +880-1000-000000</p>
          <p><strong>Address:</strong> Dhaka, Bangladesh</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
